import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';
import isToday from 'dayjs/plugin/isToday';

// 配置dayjs
dayjs.locale('zh-cn');
dayjs.extend(relativeTime);
dayjs.extend(isToday);

/**
 * 格式化日期显示
 * 如果是今天创建的，返回"今天"
 * 否则返回"YYYY-MM-DD HH:mm"格式
 */
export const formatDate = (dateStr?: string) => {
  if (!dateStr) return '-';
  
  const date = dayjs(dateStr);
  const today = dayjs().startOf('day');
  
  // 检查是否是今天
  if (date.isSame(today, 'day')) {
    return '今天';
  }
  
  // 返回年月日时分格式
  return date.format('YYYY-MM-DD HH:mm');
};

/**
 * 完整格式化日期，返回"YYYY-MM-DD HH:mm:ss"格式
 */
export const formatFullDate = (dateStr?: string) => {
  if (!dateStr) return '-';
  return dayjs(dateStr).format('YYYY-MM-DD HH:mm:ss');
};

/**
 * 获取相对时间（如：3小时前，2天前）
 */
export const getRelativeTime = (dateStr?: string) => {
  if (!dateStr) return '-';
  return dayjs(dateStr).fromNow();
}; 